import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftpowerpointComponent } from './simple-icons-microsoftpowerpoint.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftpowerpointComponent ],
    exports:      [ SimpleIconsMicrosoftpowerpointComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftpowerpointModule {}
